class Emoticons {
    constructor(CegoXMPP) {
        this.CegoXMPP = CegoXMPP;
        this.iconBaseUrl = "/assets/chat/";
        this.EMOTICON_CONTAINER = {};
        this.smileys = {
            "<:)": {
                "regex": [/&lt;:\)/g],
                "icon": "smiley_party_ani.gif"
            },
            ":)": {
                "regex": [/:\)/g, /:-\)/g],
                "icon": "smiley_smile_ani.gif"
            },
            ":D": {
                "regex": [/:D/g, /:-D/g],
                "icon": "smiley_bigsmile_ani.gif"
            },
            ":O": {
                "regex": [/:O/g, /:-O/g],
                "icon": "smiley_frightened_ani.gif"
            },
            ":P": {
                "regex": [/:P/g, /:-P/g],
                "icon": "smiley_tongue_ani.gif"
            },
            ";)": {
                "regex": [/;\)/g, /;-\)/g],
                "icon": "smiley_wink_ani.gif"
            },
            ";*": {
                "regex": [/;\*/g, /;-\*/g],
                "icon": "face-blowing-a-kiss.png"
            },
            ":(": {
                "regex": [/:\(/g, /:-\(/g],
                "icon": "smiley_unhappy_ani.gif"
            },
            ";(": {
                "regex": [/;\(/g, /;-\(/g],
                "icon": "unamused-face.png"
            },
            ":S": {
                "regex": [/:S/g, /:-S/g],
                "icon": "smiley_discomfort_ani.gif"
            },
            ":|": {
                "regex": [/:\|/g, /:-\|/g],
                "icon": "smiley_stunned_ani.gif"
            },
            ":`(": {
                "regex": [/:`\(/g, /:'\(/g],
                "icon": "smiley_crying_ani.gif"
            },
            ":$": {
                "regex": [/:\$/g, /:-\$/g],
                "icon": "smiley_shy_ani.gif"
            },
            "(h)": {
                "regex": [/\(h\)/g],
                "icon": "smiley_cool_ani.gif"
            },
            ":@": {
                "regex": [/:@/g, /:-@/g],
                "icon": "smiley_angry_ani.gif"
            },
            ":#": {
                "regex": [/:#/g, /:-#/g],
                "icon": "smiley_mute_ani.gif"
            },
            "8o|": {
                "regex": [/8o\|/g],
                "icon": "smiley_rage_ani.gif"
            },
            ":/": {
                "regex": [/:\//g],
                "icon": "smiley_thinking_ani.gif"
            },
            "8|D": {
                "regex": [/8\|D/g],
                "icon": "smiley_loon_ani.gif"
            },
            "8|": {
                "regex": [/8\|/g],
                "icon": "smiley_nerd_ani.gif"
            },
            "|0": {
                "regex": [/\|0/g],
                "icon": "smiley_sleepy_ani.gif"
            },
            "(A)": {
                "regex": [/\(A\)/g],
                "icon": "smiley_angel_ani.gif"
            },
            "(hh)": {
                "regex": [/\(hh\)/g],
                "icon": "smiley_cool2_ani.gif"
            },
            "|H": {
                "regex": [/\|H/g],
                "icon": "smiley_yelling_ani.gif"
            },
            "(|)": {
                "regex": [/\(\|\)/g, /\|\)/g],
                "icon": "smiley_ninja_ani.gif"
            },
            ".)": {
                "regex": [/\.\)/g],
                "icon": "smiley_pirate_ani.gif"
            },
            "v|": {
                "regex": [/v\|/g],
                "icon": "smiley_sad_ani.gif"
            },
            "o_O": {
                "regex": [/o_O/g],
                "icon": "smiley_wierd_ani.gif"
            },
            "><|": {
                "regex": [/&gt;&lt;\|/g],
                "icon": "smiley_realsad_ani.gif"
            },
            "O->": {
                "regex": [/O-&gt;/g],
                "icon": "smiley_alien_ani.gif"
            },
            "X-)": {
                "regex": [/X\)/gi, /X-\)/gi, /8-\)/g],
                "icon": "smiley_wondering_ani.gif"
            },
            "(yes)": {
                "regex": [/\(yes\)/g],
                "icon": "smiley_yes_ani.gif"
            },
            "(no)": {
                "regex": [/\(no\)/g],
                "icon": "smiley_no_ani.gif"
            },
            "(old)": {
                "regex": [/\(old\)/g],
                "icon": "smiley_granddaddy_ani.gif"
            },
            "(spin)": {
                "regex": [/\(spin\)/g],
                "icon": "smiley_spinaround_ani.gif"
            },
            "(tmnt)": {
                "regex": [/\(tmnt\)/g],
                "icon": "smiley_ninjaturtle_ani.gif"
            },
            "(music)": {
                "regex": [/\(music\)/g],
                "icon": "smiley_musiclistning_ani.gif"
            },
            "(hair)": {
                "regex": [/\(hair\)/g],
                "icon": "smiley_hair_ani.gif"
            },
            "(excited)": {
                "regex": [/\(excited\)/g],
                "icon": "smiley_excited_ani.gif"
            },
            "(hugesmile)": {
                "regex": [/\(hugesmile\)/g],
                "icon": "smiley_hugesmile_ani.gif"
            },
            "(hugeeyes)": {
                "regex": [/\(hugeeyes\)/g],
                "icon": "smiley_hugeeyes_ani.gif"
            },
            "(devil)": {
                "regex": [/\(devil\)/g],
                "icon": "smiley_devil_ani.gif"
            },
            "(lol)": {
                "regex": [/\(lol\)/g],
                "icon": "smiley_lol_ani.gif"
            },
            "(sleep)": {
                "regex": [/\(sleep\)/g],
                "icon": "smiley_sleeping_ani.gif"
            },
            "(waving)": {
                "regex": [/\(waving\)/g],
                "icon": "smiley_waving_ani.gif"
            },
            "(dumb)": {
                "regex": [/\(dumb\)/g],
                "icon": "smiley_dumb_ani.gif"
            },
            "(eyebrow)": {
                "regex": [/\(eyebrow\)/g],
                "icon": "smiley_eyebrow_ani.gif"
            },
            "(police)": {
                "regex": [/\(police\)/g],
                "icon": "smiley_police_ani.gif"
            },
            "(freeze)": {
                "regex": [/\(freeze\)/g],
                "icon": "smiley_freeze_ani.gif"
            },
            "(hot)": {
                "regex": [/\(hot\)/g],
                "icon": "hot-face.png"
            },
            "(zip)": {
                "regex": [/\(zip\)/g],
                "icon": "smiley_zip_ani.gif"
            },
            "(med)": {
                "regex": [/\(med\)/g],
                "icon": "face-with-medical-mask.png"
            },
            "(dollar)": {
                "regex": [/\(dollar\)/g],
                "icon": "money-mouth-face.png"
            },
            "(steam)": {
                "regex": [/\(steam\)/g],
                "icon": "face-with-steam-from-nose.png"
            },
            "(drool)": {
                "regex": [/\(drool\)/g],
                "icon": "drooling-face.png"
            },
            "(savoring)": {
                "regex": [/\(savoring\)/g],
                "icon": "face-savoring-food.png"
            },
            "(star-struck)": {
                "regex": [/\(star-struck\)/g],
                "icon": "star-struck.png"
            },
            "(thinking)": {
                "regex": [/\(thinking\)/g],
                "icon": "thinking-face.png"
            },
            "(upsidedown)": {
                "regex": [/\(upsidedown\)/g],
                "icon": "upside-down-face.png"
            },
            "(cowboy)": {
                "regex": [/\(cowboy\)/g],
                "icon": "cowboy.png"
            },
            "(monocle)": {
                "regex": [/\(monocle\)/g],
                "icon": "monocle.png"
            },
            "(heart-eyes)": {
                "regex": [/\(heart-eyes\)/g],
                "icon": "smiling-face-with-heart-eyes.png",
                "height": "19px"
            },
            "(tears-joy)": {
                "regex": [/\(tears-joy\)/g],
                "icon": "face-with-tears-of-joy.png",
                "height": "19px"
            },
        };

        this.stuff = {
            "(Y)": {
                "regex": [/\(y\)/gi],
                "icon": "stuff_thumbsup_ani.gif"
            },
            "(N)": {
                "regex": [/\(n\)/gi],
                "icon": "stuff_thumbsdown_ani.gif"
            },
            "(yn)": {
                "regex": [/\(yn\)/gi],
                "icon": "stuff_fingerscrossed_ani.gif"
            },
            "(clap)": {
                "regex": [/\(clap\)/g],
                "icon": "stuff_clapinghands_ani.gif"
            },
            "(peace)": {
                "regex": [/\(peace\)/g],
                "icon": "stuff_peacefingers_ani.gif"
            },
            "(point)": {
                "regex": [/\(point\)/g],
                "icon": "stuff_pointfinger_ani.gif"
            },
            "(wave)": {
                "regex": [/\(wave\)/g],
                "icon": "stuff_wavinghand_ani.gif"
            },
            "(strong)": {
                "regex": [/\(strong\)/g],
                "icon": "flexed-biceps.png"
            },
            "(strong-rev)": {
                "regex": [/\(strong-rev\)/g],
                "icon": "flexed-biceps-rev.png"
            },
            "(raising)": {
                "regex": [/\(raising\)/g],
                "icon": "raising-hands.png"
            },
            "(rock-on)": {
                "regex": [/\(rock-on\)/g],
                "icon": "rock-on.png"
            },
            "(pinched-fingers)": {
                "regex": [/\(pinched-fingers\)/g],
                "icon": "pinched-fingers.png"
            },
            "(L)": {
                "regex": [/\(l\)/gi],
                "icon": "stuff_heart_ani.gif"
            },
            "(U)": {
                "regex": [/\(u\)/gi],
                "icon": "stuff_heartbroken_ani.gif"
            },
            "(lovely-gift)": {
                "regex": [/\(lovely-gift\)/gi],
                "icon": "heart-with-ribbon.png"
            },
            "(man)": {
                "regex": [/\(man\)/gi],
                "icon": "stuff_man_ani.gif"
            },
            "(woman)": {
                "regex": [/\(woman\)/gi],
                "icon": "stuff_woman_ani.gif"
            },
            "({)": {
                "regex": [/\({\)/g],
                "icon": "stuff_manhug_ani.gif"
            },
            "(})": {
                "regex": [/\(}\)/g],
                "icon": "stuff_womanhug_ani.gif"
            },
            "(K)": {
                "regex": [/\(k\)/gi],
                "icon": "stuff_kiss_ani.gif"
            },
            "(goat)": {
                "regex": [/\(goat\)/g],
                "icon": "stuff_goat.png"
            },
            "(dog)": {
                "regex": [/\(dog\)/g],
                "icon": "stuff_dog_ani.gif"
            },
            "(@)": {
                "regex": [/\(@\)/g],
                "icon": "stuff_cat_ani.gif"
            },
            "(smiling-cat)": {
                "regex": [/\(smiling-cat\)/g],
                "icon": "smiling-cat-with-heart-eyes.png"
            },
            "(bat)": {
                "regex": [/\(bat\)/g],
                "icon": "stuff_bat_ani.gif"
            },
            "(bah)": {
                "regex": [/\(bah\)/g],
                "icon": "stuff_sheep_ani.gif"
            },
            "(chicken)": {
                "regex": [/\(ch\)/g, /\(chicken\)/g],
                "icon": "stuff_chicken_ani.gif"
            },
            "(duck)": {
                "regex": [/\(duck\)/g],
                "icon": "rubber-duck.png"
            },
            "(shark)": {
                "regex": [/\(shark\)/g],
                "icon": "shark.png",
                "height": "19px"
            },
            "(drink)": {
                "regex": [/\(D\)/gi, /\(drink\)/gi],
                "icon": "stuff_drink_ani.gif"
            },
            "(wine)": {
                "regex": [/\(wine\)/g],
                "icon": "wine-glass.png"
            },
            "(beer)": {
                "regex": [/\(b\)/gi, /\(beer\)/g],
                "icon": "stuff_beer_ani.gif"
            },
            "(coffee)": {
                "regex": [/\(C\)/gi, /\(coffee\)/g],
                "icon": "stuff_coffee_ani.gif"
            },
            "(^)": {
                "regex": [/\(\^\)/g],
                "icon": "stuff_birthdaycake_ani.gif"
            },
            "(pizza)": {
                "regex": [/\(pi\)/g, /\(pizza\)/g],
                "icon": "stuff_pizza_ani.gif"
            },
            "(burger)": {
                "regex": [/\(burger\)/g, /\(bu\)/g],
                "icon": "stuff_burger_ani.gif"
            },
            "(doughnut)": {
                "regex": [/\(dn\)/g, /\(doughnut\)/g],
                "icon": "stuff_doughnut_ani.gif"
            },
            "(fries)": {
                "regex": [/\(fries\)/g],
                "icon": "stuff_frenchfries_ani.gif"
            },
            "(icecream)": {
                "regex": [/\(icecream\)/g, /\(ic\)/g],
                "icon": "stuff_icecream_ani.gif"
            },
            "(softdrink)": {
                "regex": [/\(sd\)/g, /\(softdrink\)/g],
                "icon": "stuff_softdrink_ani.gif"
            },
            "(bowl)": {
                "regex": [/\(bowl\)/g],
                "icon": "stuff_bowl_ani.gif"
            },
            "(plate)": {
                "regex": [/\(plate\)/g],
                "icon": "stuff_plate_ani.gif"
            },
            "(gift)": {
                "regex": [/\(gift\)/g, /\(g\)/g],
                "icon": "stuff_gift_ani.gif"
            },
            "(o)": {
                "regex": [/\(o\)/gi],
                "icon": "stuff_time_ani.gif"
            },
            "(thermometer)": {
                "regex": [/\(thermometer\)/g],
                "icon": "thermometer.png"
            },
            "(8)": {
                "regex": [/\(8\)/g],
                "icon": "stuff_music_ani.gif"
            },
            "(I)": {
                "regex": [/\(i\)/gi],
                "icon": "stuff_lightbulp_ani.gif"
            },
            "(F)": {
                "regex": [/\(f\)/gi],
                "icon": "stuff_rose_ani.gif"
            },
            "(cigarette)": {
                "regex": [/\(ci\)/g, /\(cigarette\)/g],
                "icon": "stuff_cigarette_ani.gif"
            },
            "(computer)": {
                "regex": [/\(ci\)/g, /\(computer\)/g],
                "icon": "desktop-computer.png"
            },
            "(telephone)": {
                "regex": [/\(t\)/gi, /\(telephone\)/g],
                "icon": "stuff_telephone_ani.gif"
            },
            "(mobile)": {
                "regex": [/\(mobile\)/g, /\(mp\)/g],
                "icon": "stuff_mobile_ani.gif"
            },
            "(camera)": {
                "regex": [/\(p\)/gi, /\(camera\)/g],
                "icon": "stuff_camera_ani.gif"
            },
            "(e)": {
                "regex": [/\(e\)/gi],
                "icon": "stuff_letter_ani.gif"
            },
            "(~)": {
                "regex": [/\(~\)/g],
                "icon": "stuff_filmscroll_ani.gif"
            },
            "(umbrella)": {
                "regex": [/\(um\)/g, /\(umbrella\)/g],
                "icon": "stuff_umbrella_ani.gif"
            },
            "(%)": {
                "regex": [/\(%\)/g],
                "icon": "stuff_handcuffs_ani.gif"
            },
            "(magic)": {
                "regex": [/\(magic\)/g],
                "icon": "magic-wand.png"
            },
            "(magnify)": {
                "regex": [/\(magnify\)/g],
                "icon": "magnifying-glass.png"
            },
            "(football)": {
                "regex": [/\(so\)/g, /\(football\)/g],
                "icon": "stuff_football_ani.gif"
            },
            "(basketball)": {
                "regex": [/\(nba\)/g, /\(basketball\)/g],
                "icon": "stuff_basketball_ani.gif"
            },
            "(beachball)": {
                "regex": [/\(bb\)/g, /\(beachball\)/g],
                "icon": "stuff_beachball_ani.gif"
            },
            "(bomb)": {
                "regex": [/\(bb\)/g, /\(bomb\)/g],
                "icon": "bomb.png"
            },
            "(palms)": {
                "regex": [/\(ip\)/g, /\(palms\)/g],
                "icon": "stuff_palms_ani.gif"
            },
            "(car)": {
                "regex": [/\(au\)/g, /\(car\)/g],
                "icon": "stuff_car_ani.gif"
            },
            "(plane)": {
                "regex": [/\(ap\)/g, /\(plane\)/g],
                "icon": "stuff_plane_ani.gif"
            },
            "(rainbow)": {
                "regex": [/\(r\)/g, /\(rainbow\)/g],
                "icon": "stuff_rainbow_ani.gif"
            },
            "(rain)": {
                "regex": [/\(st\)/g, /\(rain\)/g],
                "icon": "stuff_rain_ani.gif"
            },
            "(sun)": {
                "regex": [/\(#\)/g, /\(sun\)/g],
                "icon": "stuff_sun_ani.gif"
            },
            "(star)": {
                "regex": [/\(\*\)/g, /\(star\)/g],
                "icon": "stuff_star_ani.gif"
            },
            "(moon)": {
                "regex": [/\(S\)/g, /\(moon\)/g],
                "icon": "stuff_moon_ani.gif"
            },
            "(globe)": {
                "regex": [/\(gl\)/g, /\(globe\)/g],
                "icon": "stuff_world_ani.gif"
            },
            "(d1)": {
                "regex": [/\(d1\)/g],
                "icon": "stuff_dice1_ani.gif"
            },
            "(d2)": {
                "regex": [/\(d2\)/g],
                "icon": "stuff_dice2_ani.gif"
            },
            "(d3)": {
                "regex": [/\(d3\)/g],
                "icon": "stuff_dice3_ani.gif"
            },
            "(d4)": {
                "regex": [/\(d4\)/g],
                "icon": "stuff_dice4_ani.gif"
            },
            "(d5)": {
                "regex": [/\(d5\)/g],
                "icon": "stuff_dice5_ani.gif"
            },
            "(d6)": {
                "regex": [/\(d6\)/g],
                "icon": "stuff_dice6_ani.gif"
            },
            "(candy)": {
                "regex": [/\(candy\)/g],
                "icon": "stuff_candy_ani.gif"
            },
            "(xmasgift)": {
                "regex": [/\(xmasgift\)/g],
                "icon": "stuff_christmasgift_ani.gif"
            },
            "(xmastree)": {
                "regex": [/\(xmastree\)/g],
                "icon": "stuff_christmastree_ani.gif"
            },
            "(roasted-duck)": {
                "regex": [/\(roasted-duck\)/g],
                "icon": "stuff_duck_ani.gif"
            },
            "(fireworks)": {
                "regex": [/\(fw\)/g, /\(fireworks\)/g],
                "icon": "stuff_fireworks_ani.gif"
            },
            "(ice)": {
                "regex": [/\(ice\)/g],
                "icon": "stuff_icecube_ani.gif"
            },
            "(orange)": {
                "regex": [/\(orange\)/g],
                "icon": "stuff_orange_ani.gif"
            },
            "(snow)": {
                "regex": [/\(snow\)/g],
                "icon": "stuff_snow_ani.gif"
            },
            "(fire)": {
                "regex": [/\(fire\)/g],
                "icon": "fire.png"
            },
            "(pinguin)": {
                "regex": [/\(pin\)/g, /\(pinguin\)/g],
                "icon": "stuff_pinguin_ani.gif"
            },
            "(santa)": {
                "regex": [/\(santa\)/g],
                "icon": "stuff_santa_ani.gif"
            },
            "(snowman)": {
                "regex": [/\(snowman\)/g],
                "icon": "stuff_snowman_ani.gif"
            },
            "(ghost)": {
                "regex": [/\(ghost\)/g],
                "icon": "ghost.png"
            },
            "(cancer)": {
                "regex": [/\(cas\)/g, /\(cancer\)/g],
                "icon": "stuff_cancer_ani.gif"
            },
            "(bar)": {
                "regex": [/\(bar\)/g],
                "icon": "stuff_bar_ani.gif"
            },
            "(cake)": {
                "regex": [/\(cake\)/g],
                "icon": "stuff_cake_ani.gif"
            },
            "(money)": {
                "regex": [/\(money\)/g],
                "icon": "stuff_money_ani.gif"
            },
            "(monkey)": {
                "regex": [/\(monkey\)/g],
                "icon": "monkey_new.png"
            },
            "(nono)": {
                "regex": [/\(nono\)/g],
                "icon": "stuff_nonofinger_ani.gif"
            },
            "(rocket)": {
                "regex": [/\(rocket\)/g],
                "icon": "stuff_rocketfire_ani.gif"
            },
            "(diamond)": {
                "regex": [/\(diamond\)/g],
                "icon": "te-diamond.gif"
            },
            "(apple)": {
                "regex": [/\(apple\)/g],
                "icon": "bi-gold-apple.png"
            },
            "(head)": {
                "regex": [/\(head\)/g],
                "icon": "te-head.gif"
            },
            "(watch)": {
                "regex": [/\(watch\)/g],
                "icon": "tm-watch.gif"
            },
            "(vf-bacon)": {
                "regex": [/\(vf-bacon\)/g],
                "icon": "vf-bacon.gif"
            },
            "(vf-ghost)": {
                "regex": [/\(vf-ghost\)/g],
                "icon": "vf-ghost.gif"
            },
            "(vf-newton)": {
                "regex": [/\(vf-newton\)/g],
                "icon": "vf-newton.gif"
            },
            "(brain)": {
                "regex": [/\(brain\)/g],
                "icon": "bs-brain.gif"
            },
            "(panda)": {
                "regex": [/\(panda\)/g],
                "icon": "bz-panda.gif"
            },
            "(egg)": {
                "regex": [/\(egg\)/g],
                "icon": "fe-egg.gif"
            },
            "(pool)": {
                "regex": [/\(pool\)/g],
                "icon": "golden_ball.png",
                "height": "19px"
            },
            "(bricks)": {
                "regex": [/\(bricks\)/g],
                "icon": "m3-bricks.gif"
            },
            "(bulb)": {
                "regex": [/\(bulb\)/g],
                "icon": "nw-bulb.gif"
            },
            "(monster)": {
                "regex": [/\(monster\)/g],
                "icon": "pb-monster.gif"
            },
            "(pirate)": {
                "regex": [/\(pirate\)/g],
                "icon": "pb-pirate.gif"
            },
            "(yarn)": {
                "regex": [/\(yarn\)/g],
                "icon": "yarn.png"
            },
            "(candle)": {
                "regex": [/\(candle\)/g],
                "icon": "candle.png"
            },
            "(heart-fire)": {
                "regex": [/\(heart-fire\)/g],
                "icon": "heart-on-fire.png"
            },
            "(real_rocket)": {
                "regex": [/\(real_rocket\)/g],
                "icon": "rocket.png"
            },
            "(full_moon)": {
                "regex": [/\(full_moon\)/g],
                "icon": "full-moon.png"
            },
            "(trophy)": {
                "regex": [/\(trophy\)/g],
                "icon": "trophy.png"
            },
            "(rainbow-left)": {
                "regex": [/\(rainbow-left\)/g],
                "icon": "rainbow-left.png"
            },
            "(rainbow-mid)": {
                "regex": [/\(rainbow-mid\)/g],
                "icon": "rainbow-mid.png"
            },
            "(rainbow-right)": {
                "regex": [/\(rainbow-right\)/g],
                "icon": "rainbow-right.png"
            },
            "(see-no-evil)": {
                "regex": [/\(see-no-evil\)/g],
                "icon": "see-no-evil-monkey.png",
                "height": "19px"
            },
            "(hear-no-evil)": {
                "regex": [/\(hear-no-evil\)/g],
                "icon": "hear-no-evil-monkey.png",
                "height": "19px"
            },
            "(speak-no-evil)": {
                "regex": [/\(speak-no-evil\)/g],
                "icon": "speak-no-evil-monkey.png",
                "height": "19px"
            },
            "(folded-hands)": {
                "regex": [/\(folded-hands\)/g],
                "icon": "folded-hands.png",
                "height": "19px"
            }
        };

        this.flags = {
            "(dk)": {
                "regex": [/\(dk\)/g],
                "icon": "flag-denmark.png"
            },
            "(far)": {
                "regex": [/\(far\)/g],
                "icon": "flag-faroe-islands.png"
            },
            "(gre)": {
                "regex": [/\(gre\)/g],
                "icon": "flag-greenland.png"
            },
            "(icl)": {
                "regex": [/\(icl\)/g],
                "icon": "flag-iceland.png"
            },
            "(nor)": {
                "regex": [/\(nor\)/g],
                "icon": "flag-norway.png"
            },
            "(se)": {
                "regex": [/\(se\)/g],
                "icon": "flag-sweden.png"
            },
            "(fin)": {
                "regex": [/\(fin\)/g],
                "icon": "flag-finland.png"
            },
            "(de)": {
                "regex": [/\(de\)/g],
                "icon": "flag-germany.png"
            },
            "(be)": {
                "regex": [/\(be\)/g],
                "icon": "flag-belgium.png"
            },
            "(aus)": {
                "regex": [/\(aus\)/g],
                "icon": "flag-austria.png"
            },
            "(sw)": {
                "regex": [/\(sw\)/g],
                "icon": "flag-switzerland.png"
            },
            "(fr)": {
                "regex": [/\(fr\)/g],
                "icon": "flag-france.png"
            },
            "(nl)": {
                "regex": [/\(nl\)/g],
                "icon": "flag-netherlands.png"
            },
            "(uk)": {
                "regex": [/\(uk\)/g],
                "icon": "flag-united-kingdom.png"
            },
            "(eng)": {
                "regex": [/\(eng\)/g],
                "icon": "flag-england.png"
            },
            "(sco)": {
                "regex": [/\(sco\)/g],
                "icon": "flag-scotland.png"
            },
            "(wal)": {
                "regex": [/\(wal\)/g],
                "icon": "flag-wales.png"
            },
            "(ire)": {
                "regex": [/\(ire\)/g],
                "icon": "flag-ireland.png"
            },
            "(it)": {
                "regex": [/\(it\)/g],
                "icon": "flag-italy.png"
            },
            "(es)": {
                "regex": [/\(es\)/g],
                "icon": "flag-spain.png"
            },
            "(por)": {
                "regex": [/\(por\)/g],
                "icon": "flag-portugal.png"
            },
            "(gr)": {
                "regex": [/\(gr\)/g],
                "icon": "flag-greece.png"
            },
            "(pl)": {
                "regex": [/\(pl\)/g],
                "icon": "flag-poland.png"
            },
            "(ukr)": {
                "regex": [/\(ukr\)/g],
                "icon": "flag-ukraine.png"
            },
            "(rus)": {
                "regex": [/\(rus\)/g],
                "icon": "flag-russia.png"
            },
            "(tur)": {
                "regex": [/\(tur\)/g],
                "icon": "flag-turkey.png"
            },
            "(aust)": {
                "regex": [/\(aust\)/g],
                "icon": "flag-australia.png"
            },
            "(jp)": {
                "regex": [/\(jp\)/g],
                "icon": "flag-japan.png"
            },
            "(korea)": {
                "regex": [/\(korea\)/g],
                "icon": "flag-south-korea.png",
                "height": "19px"
            },
            "(india)": {
                "regex": [/\(india\)/g],
                "icon": "flag-india.png",
                "height": "19px"
            },
            "(chi)": {
                "regex": [/\(chi\)/g],
                "icon": "flag-china.png"
            },
            "(us)": {
                "regex": [/\(us\)/g],
                "icon": "flag-united-states.png"
            },
            "(ca)": {
                "regex": [/\(ca\)/g],
                "icon": "flag-canada.png"
            },
            "(per)": {
                "regex": [/\(per\)/g],
                "icon": "flag-peru.png"
            },
            "(brazil)": {
                "regex": [/\(brazil\)/g],
                "icon": "flag-brazil.png",
                "height": "19px"
            },
            "(mada)": {
                "regex": [/\(mada\)/g],
                "icon": "flag-madagascar.png"
            },
            "(south-africa)": {
                "regex": [/\(south-africa\)/g],
                "icon": "flag-south-africa.png",
                "height": "19px"
            },
            "(ghana)": {
                "regex": [/\(ghana\)/g],
                "icon": "flag-ghana.png",
                "height": "19px"
            },
            "(ant)": {
                "regex": [/\(ant\)/g],
                "icon": "flag-antarctica.png"
            },
            "(eu)": {
                "regex": [/\(eu\)/g],
                "icon": "flag-european-union.png"
            },
            "(un)": {
                "regex": [/\(un\)/g],
                "icon": "flag-united-nations.png"
            },
            "(pride)": {
                "regex": [/\(pride\)/g],
                "icon": "flag-pride.png"
            },
            "(chequered)": {
                "regex": [/\(chequered\)/g],
                "icon": "chequered-flag.png",
                "height": "19px"
            },
            "(white)": {
                "regex": [/\(white\)/g],
                "icon": "white-flag.png",
                "height": "19px"
            },
            "(pirate-flag)": {
                "regex": [/\(pirate-flag\)/g],
                "icon": "pirate-flag.png",
                "height": "19px"
            },
        }

        this.bigOnes = {
            "(superpog)": {
                "regex": [/\(superpog\)/g],
                "icon": "superpog.png"

            },
            "(monkey-laugh)": {
                "regex": [/\(monkey-laugh\)/g],
                "icon": "monkey_laugh.png"
            },
            "(monkey-think)": {
                "regex": [/\(monkey-think\)/g],
                "icon": "monkey_think.png"
            },
            "(monkey-xmas)": {
                "regex": [/\(monkey-xmas\)/g],
                "icon": "monkey_xmas.png"
            },
            "(monkey-snow)": {
                "regex": [/\(monkey-snow\)/g],
                "icon": "monkey_snow.png"
            },
            "(thumbs)": {
                "regex": [/\(thumbs\)/g],
                "url": "https://media1.giphy.com/media/ehz3LfVj7NvpY8jYUY/giphy.gif?cid=ecf05e4715zzuk6h47w7omaoxitovwfeia03swnd90afm65g&rid=giphy.gif&ct=g"
            },
            "(dancing-banana)": {
                "regex": [/\(dancing-banana\)/g],
                "url": "https://c.tenor.com/TpWjyNO6wz8AAAAj/banana-dance.gif"
            },
            "(smile-love)": {
                "regex": [/\(smile-love\)/g],
                "url": "https://media1.giphy.com/media/hof5uMY0nBwxyjY9S2/giphy.gif?cid=ecf05e47dr4dv4xn9y0q4d2g36d1qdwa6cd2yokyggbnjp8w&rid=giphy.gif&ct=g"
            },
            "(my-love)": {
                "regex": [/\(my-love\)/g],
                "url": "https://c.tenor.com/SobspNWmkYcAAAAj/heart-glittery.gif"
            },
            "(i-love-you)": {
                "regex": [/\(i-love-you\)/g],
                "url": "https://c.tenor.com/QE1xG5SR7J0AAAAi/hearts-and-kisses-hearts.gif"
            },
            "(cute-cat)": {
                "regex": [/\(cute-cat\)/g],
                "url": "https://c.tenor.com/oFeQLr4R2zQAAAAj/peach-cat-cute.gif"
            },
            "(hooray)": {
                "regex": [/\(hooray\)/g],
                "url": "https://c.tenor.com/i7-WXEFuzrsAAAAj/yay-hooray.gif"
            },
            "(yes-yes)": {
                "regex": [/\(yes-yes\)/g],
                "url": "https://c.tenor.com/1hmGoaVATzMAAAAj/bunny-yes.gif"
            },
            "(dancing-carlton)": {
                "regex": [/\(dancing-carlton\)/g],
                "url": "https://c.tenor.com/LHKzT8b-tfcAAAAj/dance.gif"
            },
        }
    }

    getAll() {
        if (this.CegoXMPP.UserSettings.get('showSmileys')) {
            let html = "<div id='emoticons-smileys'>";
            html += this.getHTML(this.smileys);
            html += "</div><div id='emoticons-stuff'>";
            html += this.getHTML(this.stuff);
            html += "</div><div id='emoticons-flags'>";
            html += this.getHTML(this.flags);
            html += "</div><div id='emoticons-bigOnes'>";
            html += this.getHTML(this.bigOnes);
            html += "</div>";
            return html;
        } else {
            return "not available";
        }
    }

    getHTML(emoticons) {
        let html = '';
        for (let prop in emoticons) {
            let p = this.getImageProperties(emoticons[prop]);
            html += '<img class="emoji" height="' + p.height + '" src="' + p.url + '" title="' + prop + '">';
        }

        return html;
    }

    attach() {
        this.EMOTICON_CONTAINER = document.querySelector('.emoticonContainer');
        if (this.EMOTICON_CONTAINER) {
            this.EMOTICON_CONTAINER.innerHTML = this.getAll();
            const icons = this.EMOTICON_CONTAINER.querySelectorAll('.emoji');
            for (let i = 0; i < icons.length; i++) {
                icons[i].addEventListener('click', function (event) {
                    const inputMessage = document.querySelector(this.CegoXMPP.chatContainer + ' .chatText');
                    const icon = event.target.getAttribute('title');
                    let mess = inputMessage.value;
                    let pre = mess.substring(0, window.savedSelection);
                    let post = mess.substring(window.savedSelection);
                    inputMessage.value = pre + icon + post;
                    window.savedSelection += icon.length;
                    inputMessage.focus();
                    inputMessage.setSelectionRange(window.savedSelection, window.savedSelection)
                    if (event.target.parentElement.id === "emoticons-bigOnes") {
                        this.CegoXMPP.sendAction($(inputMessage));
                        this.close();
                    }
                }.bind(this));
            }

            document.querySelector(this.CegoXMPP.chatContainer).onclick = function (e) {
                this.toggle();
            }.bind(this);
        }
    }

    toggle() {
        if (this.EMOTICON_CONTAINER.classList.contains("active")) {
            this.EMOTICON_CONTAINER.classList.remove("active");
        } else {
            this.EMOTICON_CONTAINER.classList.add("active");
        }
    }

    close() {
        this.EMOTICON_CONTAINER.classList.remove("active");
    }

    getImageProperties(prop) {
        let p = {};
        if (typeof prop.url === "string") {
            p.url = prop.url
        } else if (typeof prop.icon === "string") {
            p.url = this.iconBaseUrl + prop.icon
        }
        if (typeof prop.height === "string") {
            p.height = prop.height;
        } else {
            p.height = "auto"
        }
        return p;
    }

    replaceIcons(message) {
        if (!message) {
            return "";
        }
        let emoticons = [];
        let remove = [];
        if (this.CegoXMPP.UserSettings.get('showSmileys')) {
            for (let attr in this.smileys) {
                emoticons[attr] = this.smileys[attr];
            }
            for (let attr in this.stuff) {
                emoticons[attr] = this.stuff[attr];
            }
            for (let attr in this.flags) {
                emoticons[attr] = this.flags[attr];
            }
            if (this.CegoXMPP.UserSettings.get('showAnimations')) {
                for (let attr in this.bigOnes) {
                    emoticons[attr] = this.bigOnes[attr];
                }
            } else {
                for (let attr in this.bigOnes) {
                    remove[attr] = this.bigOnes[attr];
                }
            }
        } else {
            for (let attr in this.smileys) {
                remove[attr] = this.smileys[attr];
            }
            for (let attr in this.stuff) {
                remove[attr] = this.stuff[attr];
            }
            for (let attr in this.flags) {
                remove[attr] = this.flags[attr];
            }
            for (let attr in this.bigOnes) {
                remove[attr] = this.bigOnes[attr];
            }
        }
        if (message.indexOf("https://") >= 0) {
            if (message.indexOf(window.location.origin) >= 0) {
                if (message.indexOf("https://") === 0) {
                    let end = message.length + 1;
                    if (message.indexOf(" ") > 0) {
                        end = message.indexOf(" ") + 1;
                    }
                    let link = message.substring(0, end);
                    message = "<a target='_blank' href='" + link + "'>" + message.replace(window.location.origin, "") + "</a>"
                } else {
                    message = message.replace(window.location.origin, "");
                }
            } else {
                message = "<img src='/assets/chat/unamused-face.png'>";
            }
        } else {
            for (let prop in emoticons) {
                for (let i in emoticons[prop].regex) {
                    let p = this.getImageProperties(emoticons[prop]);
                    message = message.replace(emoticons[prop].regex[i], "<img height='" + p.height + "' src='" + p.url + "'/>");
                }
            }
            for (let prop in remove) {
                for (let i in remove[prop].regex) {
                    message = message.replace(remove[prop].regex[i], "");
                }
            }
        }

        return message;
    }
}
